import { Role, User } from '../models/user.model';
import { AuthenticationService } from './authentication.service';
import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Headers } from '@angular/http';


@Injectable()
export class UsersService {
  private loggedUser: User = null;

  constructor(
    private http: GlobalService,
    private entityService: EntityService,
    private authenticationService: AuthenticationService) {

    this.authenticationService.loginNotifier.subscribe(result => {
      this.loggedUser = null;
    });
  }

  public get currentUserFresh(): Observable<User> {
    const url = `users/current`;
    return this.http.get(url)
      .map(res => this.entityService.extractData<User>(res))
      .map(data => {

        const user = this.entityService.copy(data, new User());
        user.roles = [];
        if (data.roles) {
          data.roles.forEach(role => {
            user.roles.push(this.entityService.copy(role, new Role()));
          });

        }
        return user;
      }).map(user => {
        this.loggedUser = user;
        return this.loggedUser;
      });
  }

  public get currentUser(): Observable<User> {
    if (this.loggedUser) {
      return Observable.of(this.loggedUser);
    }

    const url = `users/current`;
    return this.http.get(url)
      .map(res => this.entityService.extractData<User>(res))
      .map(data => {

        const user = this.entityService.copy(data, new User());
        user.roles = [];
        if (data.roles) {
          data.roles.forEach(role => {
            user.roles.push(this.entityService.copy(role, new Role()));
          });

        }
        return user;
      }).map(user => {
        this.loggedUser = user;
        return this.loggedUser;
      });
  }

  getUserManual(): Observable<any> {
    const url = `users/userManualDownload`;

    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.append('responseType', 'arrayBuffer');

    return this.http.file(url, null, headers)
      .map(x => {
        const blob = new Blob([x.payload.blob()], { type: 'application/pdf' });

        var fileURL = URL.createObjectURL(blob);
        window['saveAs'](blob, 'Manual de Usuario.pdf');

        window['open'](fileURL);
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/users.service.ts